const Event = {

    // BUTTON
    "details": "View Details",

    // PAGE HEADER
    "tagline": "Events That Bring Us Together ",

    // FIELDS
    "category": "Category",
    "date": "Date",
    "city": "City",

}

export default Event;